import {createContext, useContext} from 'react'

const TableContext = createContext()

export const TableContextProvider = (props) => {
    return <TableContext.Provider {...props} />
}

export const useTableContext = () => useContext(TableContext)
